import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export function IntroStep({
  type,
  appName
}) {
  if (type === 'OAuth' || type === 'OAuthWithPolling') {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      "data-test-id": "oauth-intro",
      message: "unifiedAuthCore.auth.connectDefaultOAuthIntro",
      options: {
        appName
      }
    });
  }
  return null;
}